import React from "react";
import { EcpStudentEnrollmentsSplitview } from "../components/splitviews/ecp-student-enrollments-splitview";

export function EcpStudentsPage(props) {
  return <EcpStudentEnrollmentsSplitview {...props} />;
}
